// action types
export const SET_REREGISTRATION_STATUS = "setReRegistrationStatus";

// mutation types
export const SET_LOADING_MENU = "setLoadingMenu";

export default {
  state: {
    loadingMenu: false,
    reRegistrationStatus: ""
  },
  mutations: {
    [SET_LOADING_MENU] (state, loadingStatus) {
      state.loadingMenu = loadingStatus;
    },
    [SET_REREGISTRATION_STATUS] (state, status) {
      state.reRegistrationStatus = status;
    }
  }
};
